/**
 * Конвертирует base64 строку в data URI для использования в img src
 */
export const base64ToDataUri = (base64String) => {
    if (!base64String) return null;
    // Проверяем, не является ли уже data URI
    if (base64String.startsWith('data:')) return base64String;
    // Конвертируем base64 в data URI (по умолчанию PNG, можно определить по контексту)
    return `data:image/png;base64,${base64String}`;
};

/**
 * Получает иконку для подразделения
 * Приоритет: custom_subdivision_icon -> department_icon -> null
 */
export const getSubdivisionIcon = (subdivisionUUID, departmentUUID, iconsData) => {
    if (!iconsData) return null;

    // Проверяем наличие custom иконки для подразделения
    const customIcon = iconsData.subdivisions?.find(
        sub => sub.subdivision_uuid === subdivisionUUID
    )?.custom_subdivision_icon;

    if (customIcon) return base64ToDataUri(customIcon);

    // Если нет, используем иконку отдела
    const departmentIcon = iconsData.groups?.find(
        group => group.uuid === departmentUUID
    )?.icon;

    return departmentIcon ? base64ToDataUri(departmentIcon) : null;
};

/**
 * Получает иконку отдела
 */
export const getDepartmentIcon = (departmentUUID, iconsData) => {
    if (!iconsData) return null;
    const icon = iconsData.groups?.find(group => group.uuid === departmentUUID)?.icon;
    return icon ? base64ToDataUri(icon) : null;
};

/**
 * Динамически рассчитывает количество элементов в колонке
 * Для одной колонки возвращаем 10 или общее количество, если оно меньше 10.
 */
export const calculateColumnsPerRow = (count) => {
    if (!count || count <= 0) return 1;
    return count > 10 ? 10 : count;
};

/**
 * Рассчитывает количество элементов на строку в мобильной версии
 * Использует то же правило, что и calculateColumnsPerRow
 */
export const calculateMobileElementsPerRow = (count) => {
    return calculateColumnsPerRow(count);
};

/**
 * Группирует элементы в колонки на основе количества элементов
 */
export const groupElementsIntoColumns = (elements, columnsPerRow) => {
    const columns = [];
    for (let i = 0; i < elements.length; i += columnsPerRow) {
        columns.push(elements.slice(i, i + columnsPerRow));
    }
    return columns;
};
